(() => {
  const STEPS = [1099, 1599, 2999];
  const TITLES = ["10% OFF", "Free Napkins", "Free Gift Hamper"];

  // ✅ Match CSS positions
  const STEP_POSITIONS = [15, 55, 95, 100];

  const updateUI = (root, cart) => {
    if (!root || !cart) return;

    const fill = root.querySelector("#progressFill");
    const msg = root.querySelector("#offerMessage");
    const icons = root.querySelectorAll(".icon-milestone");

    if (!fill || !msg) return;

    const total = (cart.total_price || 0) / 100;

    let visualPercent = 0;

    // ✅ Segment 1 (0 → 999)
    if (total <= STEPS[0]) {
      const p = total / STEPS[0];
      visualPercent = p * STEP_POSITIONS[0];

    // ✅ Segment 2 (999 → 1599)
    } else if (total <= STEPS[1]) {
      const p = (total - STEPS[0]) / (STEPS[1] - STEPS[0]);
      visualPercent =
        STEP_POSITIONS[0] +
        p * (STEP_POSITIONS[1] - STEP_POSITIONS[0]);

    // ✅ Segment 3 (1599 → 2999)
    } else if (total <= STEPS[2]) {
      const p = (total - STEPS[1]) / (STEPS[2] - STEPS[1]);
      visualPercent =
        STEP_POSITIONS[1] +
        p * (STEP_POSITIONS[2] - STEP_POSITIONS[1]);

    // ✅ Beyond goal
    } else {
      visualPercent = STEP_POSITIONS[3];
    }

    fill.style.width = `${visualPercent}%`;

    // Activate icons
    icons.forEach((icon, i) => {
      icon.classList.toggle("active", total >= STEPS[i]);
    });

    // Message
    const next = STEPS.find((v) => total < v);

    msg.textContent = next
      ? `Add Rs. ${Math.ceil(next - total)} more for ${TITLES[STEPS.indexOf(next)]}`
      : "🎉 All offers unlocked!";
  };

  const fetchAndRefresh = (root) =>
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => updateUI(root, cart))
      .catch((e) => console.error("Cart fetch error:", e));

  const init = () => {
    const root = document.querySelector("#offerWrapper");
    if (!root || root.dataset.offerInit) return;

    root.dataset.offerInit = "1";
    fetchAndRefresh(root);
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("cart:refresh", init);
  document.addEventListener("cart:updated", init);
  document.addEventListener("cart:drawer:open", init);

  new MutationObserver(init).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();